const PaymentProvider = {
    PAYGREEN: 'PAYGREEN',
    PAYZEN: 'PAYZEN',
    PAYPAL: 'PAYPAL',
    STRIPE: 'STRIPE',
    CREDIT_CARD: 'CREDIT_CARD',
    GOOGLE_PAY: 'GOOGLE_PAY',
    APPLE_PAY: 'APPLE_PAY',
    SWILE: 'SWILE',
    EDENRED: 'EDENRED',
  };

const PaymentMethod = {
  CB: 'cb',
  EDENRED: 'edenred',
  APPLE_GOOGLE_PAY: 'applePay/googlePay',
  CARDS: 'CARDS',
};
  
  
  const PAYZEN_3DS_ERROR_CODES = [
    '39',
    '149',
    '205',
    '206',
    '207',
  ];
  
  export { PaymentProvider, PAYZEN_3DS_ERROR_CODES, PaymentMethod };